var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 41 28","fill":"none"}},[_c('path',{attrs:{"d":"M27.36 1L40 13.64 27.36 26.28M1.708 13.5h37.584"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }